import axiosInstance from '@/app/api/axiosInstance';
import {
    OutstandingInvoice,
    PaymentReceivedMultiInvoiceCreate,
    VoucherResponse,
} from '@/app/types/payment';

interface RawOutstandingInvoice {
    id: number;
    voucher_number: string;
    transaction_date: string;
    total_amount: string | number;
    amount_due: string | number | null;
}

export const listOutstandingInvoices = async (
    partyId: number
): Promise<OutstandingInvoice[]> => {
    const response = await axiosInstance.get<RawOutstandingInvoice[]>(
        `/payments/parties/${partyId}/outstanding-invoices`
    );
    const items = response.data || [];
    return items.map((inv) => ({
        id: inv.id,
        voucher_number: inv.voucher_number,
        transaction_date: inv.transaction_date,
        total_amount: Number(inv.total_amount ?? 0),
        amount_due: Number(inv.amount_due ?? inv.total_amount ?? 0),
    }));
};

export const recordPaymentIn = async (
    payload: PaymentReceivedMultiInvoiceCreate
): Promise<VoucherResponse> => {
    const response = await axiosInstance.post<VoucherResponse>(
        '/payments/receive-multi',
        payload
    );
    return response.data;
};
